module.exports = __webpack_public_path__ + "img/1F1F1-1F1FB.89f6b105.svg";